import data from 'data/results.json'
import orderBy from 'lodash/orderBy'

interface TypeMatchedCount {
  type: ResultType
  matchedCount: number
}

/**
 * find the result type whose answers match the most.
 * refer 'src/data/answersToResult.json'
 */
const getResultType = (userAnswers: number[]): ResultType => {
  // 1. get matched answer counts of each type
  const typeWithMatchedCount: TypeMatchedCount[] = []
  for (const index in data) {
    const { answers: typeAnswers, type } = data[index]

    const matchedCount = typeAnswers.reduce(
      (count, typeAnswer, currentIndex) => {
        const isMatched = typeAnswer === userAnswers[currentIndex]
        return isMatched ? ++count : count
      },
      0,
    )
    typeWithMatchedCount.push({ type: type as ResultType, matchedCount })
  }

  // 2. order types by matchedCount
  const typesOrderByMatchedCount = orderBy(
    typeWithMatchedCount,
    ['matchedCount', 'type'],
    ['desc', 'asc'], // first order by matchedCount if matchedCount is equal then order by type
  )

  // 3. return 'result'
  // + index 1 can be 'close type', and last index can be 'distant type'
  return typesOrderByMatchedCount[0].type
}

export default getResultType
